import { DateBadgeInput } from "@/lib/Components/Form/Inputs/DateBadgeInput";

export function ClosedDropoffDatesForm() {
  return (
    <DateBadgeInput
      className="col-span-full"
      name="closed_delivery_dates"
      label="Closed drop-off dates"
    />
  );
}
